import React from 'react';
import ImageCarousel from './ImageCarousel';
import { parsePostContent } from '../types/PostContent';

interface PostContentRendererProps {
  content: string;
  className?: string;
}

const PostContentRenderer: React.FC<PostContentRendererProps> = ({
  content,
  className = ""
}) => {
  const postContent = parsePostContent(content);

  return (
    <div className={`post-content-container ${className}`}>
      {/* Images Carousel - Instagram Style */}
      {postContent.images.length > 0 && (
        <div className="mb-4">
          <ImageCarousel images={postContent.images} />
        </div>
      )}

      {/* Text Content */}
      {postContent.text && (
        <div
          className="post-content"
          dangerouslySetInnerHTML={{ __html: postContent.text }}
          style={{
            fontSize: '14px',
            lineHeight: '1.5',
            color: '#262626',
            wordWrap: 'break-word',
          }}
        />
      )}

      {/* Fallback for empty content */}
      {!postContent.text && postContent.images.length === 0 && (
        <div className="text-gray-400 italic text-sm">
          Conteúdo não disponível
        </div>
      )}
    </div>
  );
};

export default PostContentRenderer;